import { getCsrfToken } from "@/lib/helpers/csrf-token";

export function buildCsrfHeaders(): Record<string, string> {
  const csrfToken = getCsrfToken();
  const headers: Record<string, string> = {};

  if (csrfToken) {
    headers["X-CSRFToken"] = csrfToken;
  }

  return headers;
}
